//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingNeutral(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z" fill="currentColor" /><path d="M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z" fill="currentColor" /><path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor" /><path d="M16 14H8V16H16V14Z" fill="currentColor" /></svg>;
}
export default IconRatingNeutral;